export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/singers_vocalists.7778ec0.svg";